import React, { useEffect, useState } from "react";
import ViewModal from "@core/modals/ViewModal";
import ViewButton from "@core/buttons/atoms/ViewButton";
import RowDetails from "@hoc/cruds/RowDetails";
import { useTranslation } from "react-i18next";
import PermissionHandler from "@hoc/cruds/PermissionHandler";
import EnergySourceService from "@services/EnergySourceService";

const ShowEnergySource = ({ energySource }) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [energySourceData, setEnergySource] = useState([]);

  const closeModal = () => {
    setShowModal(false);
  };
  useEffect(() => {
    if (showModal)
      EnergySourceService.find(energySource.id).then((response) => {
        setEnergySource(response.data.data);
      });
  }, [energySource.id, showModal]);

  return (
    <PermissionHandler permission={"view_energy_sources"}>
      <ViewButton onClick={() => setShowModal(true)} />
      <ViewModal
        show={showModal}
        title={`${t("overview")}`}
        onClose={closeModal}
      >
        <div className="flex flex-col mt-5">
          <RowDetails label={t("name")} value={energySourceData.name} />
          <RowDetails label={t("nameEng")} value={energySourceData.name_eng} />
          <RowDetails
            label={t("description")}
            value={energySourceData.description}
          />
        </div>
      </ViewModal>
    </PermissionHandler>
  );
};

export default ShowEnergySource;
